import {type GlobalState} from 'types/store';

import {getCurrentTeam} from 'mattermost-redux/selectors/entities/teams';
import {getConfig, getLicense} from 'mattermost-redux/selectors/entities/general';

import {haveICurrentTeamPermission} from 'mattermost-redux/selectors/entities/roles';
import Permissions from 'mattermost-redux/constants/permissions';

import {getAllowedCurrentTeamDomains, getAllowedTeamDomains, getAllowedGuestDomains} from './get_allowed_domains';
import {getInvitableChannels} from './get_invitable_channels';
import {getArchivedChannelsMap} from './get_archived_channels';

export function getInviteMembersData(state: GlobalState) {
    const config = getConfig(state);

    const guestsEnabled = config.EnableRestrictedGuestAccounts === 'true';
    const guestsPlusEnabled = config.EnableGuestAccounts === 'true';
    const haveInviteGuestPermission = haveICurrentTeamPermission(state, Permissions.INVITE_GUEST);

    return {
        allowedCurrentTeamDomains: getAllowedCurrentTeamDomains(state),
        allowedGuestDomains: getAllowedGuestDomains(state),
        allowedTeamDomains: getAllowedTeamDomains(state),
        archivedChannelsMap: getArchivedChannelsMap(state),
        canAddMembers: haveICurrentTeamPermission(state, Permissions.ADD_USER_TO_TEAM),
        canInviteGuests: guestsEnabled && haveInviteGuestPermission,
        canInviteGuestsPlus: guestsPlusEnabled && haveInviteGuestPermission,
        channels: getInvitableChannels(state),
        config,
        currentTeam: getCurrentTeam(state),
        license: getLicense(state),
    };
}
